import React, { useState, useEffect } from "react";
import clinicService from "../../services/clinic.service";

const WelcomeForm = ({ preferences,clinicId,pid,puid,utype,udata }) => {
  const [epref, setEPref] = useState(0);
  const [spref, setSPref] = useState(0);
  const [tpref, setTPref] = useState(0);
  const [alert,setAlert] = useState();
  const [successAlert,setSuccessAlert] = useState();
  {/** Switches Values  Default off*/}
    const [recallStatus,setRecallStatus] = useState(false)
    const [glassStatus,setGlassStatus] = useState(false)
    const [lensStatus,setLensStatus] = useState(false)
    const [newsletterStatus,setNewsletterStatus] = useState(false)
    const [articleStatus,setArticleStatus] = useState(false)
    const [surveyStatus,setSurveyStatus] = useState(false)
    const [followupStatus,setFollowupStatus] = useState(false)
    const [birthdayStatus,setBirthdayStatus] = useState(false)

  const [iconsent,setIconsent] = useState()

  const handleEmailChange = (e) => {
    const tempVal = epref;
    const sVal = e.target.value;
    setEPref(sVal);
    if(spref == sVal) setSPref(tempVal) 
    if(tpref == sVal) setTPref(tempVal)

   };
  const handleSmsChange = (e) => {
    const tempVal = spref;
    const sVal = e.target.value;
    setSPref(sVal);
    if(tpref == sVal) setTPref(tempVal) 
    if(epref == sVal) setEPref(tempVal)
  };
  const handlePhoneChange = (e) => {
    const tempVal = tpref;
    const sVal = e.target.value;
    setTPref(sVal);
    if(epref == sVal) setEPref(tempVal) 
    if(spref == sVal) setSPref(tempVal)
  };

  useEffect(() => {
    setEPref(preferences.prefEmail);
    setSPref(preferences.prefSms);
    setTPref(preferences.prefCall);

    setRecallStatus(preferences.recallStatus==1?true:false)
    setGlassStatus(preferences.glassStatus==1?true:false)
    setLensStatus(preferences.lensStatus==1?true:false)
    setNewsletterStatus(preferences.newsletterStatus==1?true:false)
    setArticleStatus(preferences.articleStatus==1?true:false)
    setSurveyStatus(preferences.surveyStatus==1?true:false)
    setFollowupStatus(preferences.followupStatus==1?true:false)
    setBirthdayStatus(preferences.birthdayStatus==1?true:false )
    setIconsent(preferences.status==1?true:false)
   console.log(preferences)
  }, []);

  const handleSubmit = ()=>{
    setAlert(null)
    setSuccessAlert(null)
    if(iconsent){
        if(preferences.email && epref==0) setAlert("Please Select Email Preference")
        if(preferences.cellNumber && spref==0) setAlert("Please Select SMS Preference")
        if(preferences.phoneNumber && tpref==0) setAlert("Please Select Phone Preference")
        
        const newPref = {
            ...preferences,
            prefEmail:epref,
            prefSms:spref,
            prefCall:tpref,
            recallStatus:recallStatus?1:0,
            glassStatus:glassStatus?1:0,
            lensStatus:lensStatus?1:0,
            newsletterStatus:newsletterStatus?1:0,
            articleStatus:articleStatus?1:0,
            surveyStatus:surveyStatus?1:0,
            followupStatus:followupStatus?1:0,
            birthdayStatus:birthdayStatus?1:0,
            status:1
          }

        console.log(newPref)
        clinicService.updatePatientPref(clinicId,pid,puid,utype,udata,newPref)
        .then(res=>{
          setSuccessAlert("Preferences Updated Successfully.")
        })
        .catch(err=>{
          console.log(err)
        })

    }else{
      setAlert("Please check the consent box!")
    }
  }

 
  return (
    <>
      <div className="container mt-4">
        <div className="d-flex justify-content-between">
          <h3>Contact Preferences</h3>
        </div>
        {alert &&
        <div className="row mt-2">
            <div className="col-12">
              <div className="alert alert-danger">{alert}</div>
            </div>
        </div>
        }
        {successAlert &&
        <div className="row mt-2">
          <div className="col-12">
            <div className="alert alert-success">{successAlert}</div>
          </div>
        </div>
        }
       
        <div className="row mt-3">
          <div className="col-md-4 mt-2">
            <div className="card text-bg-light">
              <div className="card-body">
                <div className="d-lg-flex justify-content-between">
                  <div className="card-title">
                    <i className="bi bi-send-fill"></i> Email
                  </div>
                  <select
                    name=""
                    id=""
                    value={epref}
                    onChange={(e) => handleEmailChange(e)}
                    className="form-select-sm"
                  >
                    <option value="0">Please Select</option>
                    <option value="1">Primary Method</option>
                    <option value="2">Secondary Method</option>
                    <option value="3">Tertiary Method</option>
                  </select>
                </div>
              </div>
              <div className="card-subtitle mb-2 ms-2 text-muted">
                <small>Your email: {preferences.email}</small>
              </div>
            </div>
          </div>
          <div className="col-md-4 mt-2">
            <div className="card text-bg-light">
              <div className="card-body">
                <div className="d-lg-flex justify-content-between">
                  <div className="card-title">
                    <i className="bi bi-envelope-fill"></i> SMS
                  </div>
                  <select
                    name=""
                    id=""
                    value={spref}
                    onChange={(e) => handleSmsChange(e)}
                    className="form-select-sm"
                  >
                    <option value="0">Please Select</option>
                    <option value="1">Primary Method</option>
                    <option value="2">Secondary Method</option>
                    <option value="3">Tertiary Method</option>
                  </select>
                </div>
              </div>
              <div className="card-subtitle mb-2 ms-2 text-muted">
                <small>Your phone number: {preferences.cellNumber}</small>
              </div>
            </div>
          </div>
          <div className="col-md-4 mt-2">
            <div className="card text-bg-light">
              <div className="card-body">
                <div className="d-lg-flex justify-content-between">
                    <div className="card-title">
                    <i className="bi bi-telephone-fill"></i> Telephone
                    </div>
                    <select
                  name=""
                  id=""
                  value={tpref}
                  onChange={(e) => handlePhoneChange(e)}
                  className="form-select-sm"
                >
                  <option value="0">Please Select</option>
                  <option value="1">Primary Method</option>
                  <option value="2">Secondary Method</option>
                  <option value="3">Tertiary Method</option>
                </select>
                </div>
              </div> 
                <div className="card-subtitle mb-2 ms-2 text-muted">
                  <small> Your phone number: {preferences.phoneNumber}</small>
                </div>
              
              
            </div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col p-3 ms-3">
            <div className="form-check form-switch">
              {recallStatus &&
                <input
                type="checkbox"
                defaultChecked = {recallStatus && "checked"}
                id="chkRecall"
                className="form-check-input"
                onClick={()=>{setRecallStatus(!recallStatus)}}
              />
              }
              {!recallStatus &&
                <input
                type="checkbox"
                defaultChecked = {recallStatus && "checked"}
                id="chkRecall"
                className="form-check-input"
                onClick={()=>{setRecallStatus(!recallStatus)}}
              />
              }
             
              <label htmlFor="chkRecall" className="form-check-label">
                {" "}
                Appointment & Recall Reminder
              </label>
            </div>
            <div className="form-check form-switch">
              {glassStatus && 
                <input 
                type="checkbox" 
                className="form-check-input"
                defaultChecked={glassStatus?"checked":""}
                onClick={()=>{setGlassStatus(!glassStatus)}}
                />
              }
               {!glassStatus && 
                <input 
                type="checkbox" 
                className="form-check-input"
                defaultChecked={glassStatus?"checked":""}
                onClick={()=>{setGlassStatus(!glassStatus)}}
                />
              }
              
              <label htmlFor="" className="form-check-label">
                {" "}
                Glasses Pickup Reminder
              </label>
            </div>
            <div className="form-check form-switch">
              {lensStatus &&
                <input 
                type="checkbox" 
                defaultChecked={lensStatus?"checked":""}
                onClick={()=>{setLensStatus(!lensStatus)}}
                className="form-check-input" />
              }
               {!lensStatus &&
                <input 
                type="checkbox" 
                defaultChecked={lensStatus?"checked":""}
                onClick={()=>{setLensStatus(!lensStatus)}}
                className="form-check-input" />
              }
              
              <label htmlFor="" className="form-check-label">
                {" "}
                Contact Lens Pickup Reminder
              </label>
            </div>
            <div className="form-check form-switch">
              {newsletterStatus &&
              <input 
                type="checkbox" 
                defaultChecked={newsletterStatus?"checked":""}
                onClick={()=>{setNewsletterStatus(!newsletterStatus)}}
                className="form-check-input" />
              }
               {!newsletterStatus &&
              <input 
                type="checkbox" 
                defaultChecked={newsletterStatus?"checked":""}
                onClick={()=>{setNewsletterStatus(!newsletterStatus)}}
                className="form-check-input" />
              }
              <label htmlFor="" className="form-check-label">
                {" "}
                Newsletter and Promotions
              </label>
            </div>
            <div className="form-check form-switch">
              {articleStatus && 
              <input 
                type="checkbox" 
                defaultChecked={articleStatus?"checked":""}
                onClick={()=>{setArticleStatus(!articleStatus)}}
                className="form-check-input" />
              }
               {!articleStatus && 
              <input 
                type="checkbox" 
                defaultChecked={articleStatus?"checked":""}
                onClick={()=>{setArticleStatus(!articleStatus)}}
                className="form-check-input" />
              }
              <label htmlFor="" className="form-check-label">
                {" "}
                Specific education about my eye conditions send by my eyecare
                provider
              </label>
            </div>
            <div className="form-check form-switch">
              {surveyStatus &&
              <input 
                type="checkbox" 
                defaultChecked={surveyStatus?"checked":""}
                onClick={()=>{setSurveyStatus(!surveyStatus)}}
                className="form-check-input" />
              }
               {!surveyStatus &&
              <input 
                type="checkbox" 
                defaultChecked={surveyStatus?"checked":""}
                onClick={()=>{setSurveyStatus(!surveyStatus)}}
                className="form-check-input" />
              }

              <label htmlFor="" className="form-check-label">
                {" "}
                Surveys
              </label>
            </div>
            <div className="form-check form-switch">
              {followupStatus &&
              <input 
                type="checkbox" 
                defaultChecked={followupStatus?"checked":""}
                onClick={()=>{setFollowupStatus(!followupStatus)}}
                className="form-check-input" />
              }
              {!followupStatus &&
              <input 
                type="checkbox" 
                defaultChecked={followupStatus?"checked":""}
                onClick={()=>{setFollowupStatus(!followupStatus)}}
                className="form-check-input" />
              }
              <label htmlFor="" className="form-check-label">
                {" "}
                Follow Ups
              </label>
            </div>
            <div className="form-check form-switch">
              {birthdayStatus &&
              <input 
                type="checkbox" 
                defaultChecked={birthdayStatus?"checked":""}
                onClick={()=>{setBirthdayStatus(!birthdayStatus)}}
                className="form-check-input" />
              }
               {!birthdayStatus &&
              <input 
                type="checkbox" 
                defaultChecked={birthdayStatus?"checked":""}
                onClick={()=>{setBirthdayStatus(!birthdayStatus)}}
                className="form-check-input" />
              }
              <label htmlFor="" className="form-check-label">
                {" "}
                Birthday Greetings
              </label>
            </div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col">
            <div className="form-check">
              {iconsent && 
                <input 
                type="checkbox" 
                defaultChecked = {iconsent?"checked":""}
                onClick={()=>{setIconsent(!iconsent)}}
                className="form-check-input"
                 />
              }
            
              <label htmlFor="" className="form-check-label">
                {" "}
                I ({preferences.firstName + " " + preferences.lastName}), hereby
                express my consent to be contacted electronically for the above
                purposes.
              </label>
            </div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-12">
            <button className="btn btn-lg btn-secondary" type="button" onClick={handleSubmit}>Submit</button>
           
          </div>
        </div>
      </div>
    
    </>
  );
};

export default WelcomeForm;
